import {isEmptyObject} from "./utils/is-empty-object";
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {RenderPosition, render} from "./utils/render";
import BannerListComponent from "./components/banner-list-component";
import BannerComponent from "./components/banner-component";
import LiComponent from "./components/li";
import BannerNavComponent from "./components/banner-nav-component";


const getBannerData = (product) => {
  return {
    title: product.title || ``,
    link: product.link || ``,
    imgSrc: product.image || ``,
    imgSrcMobile: product.image_mob || ``,
  };
};

export const renderBannerList = (container, data) => {
  const bannerList = data;
  if (isEmptyObject(bannerList)) {
    return;
  }

  const wrapComponent = new BannerListComponent();
  const bannerListElement = wrapComponent.getElement().querySelector(`.banner__list`);

  Object.keys(bannerList)
  .forEach((itemId) => {
    const banner = bannerList[itemId];
    const liItemComponent = new LiComponent({
      className: `banner__item swiper-slide`,
    });
    render(bannerListElement, liItemComponent.getElement(), RenderPosition.BEFOREEND);

    const bannerCardComponent = new BannerComponent({
      data: getBannerData(banner),
    });

    render(liItemComponent.getElement(), bannerCardComponent.getElement(), RenderPosition.BEFOREEND);
  });

  render(container, wrapComponent.getElement(), RenderPosition.BEFOREEND);

  const navigationComponent = new BannerNavComponent();
  render(container, navigationComponent.getElement(), RenderPosition.BEFOREEND);


  const sw = new Swiper(`.banner__wrap`, {
    modules: [Autoplay, Navigation, Pagination],
    direction: `horizontal`,
    loop: true,
    slidesPerView: 1,
    autoHeight: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    pagination: {
      el: `.swiper-pagination`,
    },

    navigation: {
      nextEl: `.swiper__button--next`,
      prevEl: `.swiper__button--prev`,
      hiddenClass: `main-page__swiperButton--hidden`,
      disabledClass: `main-page__swiperButton--disabled`,
      lockClass: `main-page__swiperButton--lock`
    },
  });
};
